import { render, staticRenderFns } from "./detail-coupon.vue?vue&type=template&id=3a3e2510&scoped=true&"
import script from "./detail-coupon.vue?vue&type=script&lang=js&"
export * from "./detail-coupon.vue?vue&type=script&lang=js&"
import style0 from "./detail-coupon.vue?vue&type=style&index=0&id=3a3e2510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e2510",
  null
  
)

export default component.exports